<payee-popup
  [heading]="'CLIENT_ACCESS.DELETE.TITLE' | translate"
  [description]="'CLIENT_ACCESS.DELETE.DESCRIPTION' | translate: { name: client.name || '' }"
>
  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      color="alert-red"
      width="max"
      [disabled]="submitLoading"
      (click)="submit()"
    >
      {{ "CLIENT_ACCESS.DELETE.CONFIRM" | translate }}
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="white"
      width="max"
      mat-dialog-close
      [isBorderButton]="true"
    >
      {{ "CANCEL" | translate }}
    </button>
  </ng-template>
</payee-popup>
